import React, { Component } from "react";
import styled, { css } from "styled-components";
import Swiper from "swiper/js/swiper.js";

import WP from "WP";

import Container from "partials/Container";
import GridElement from "partials/GridElement";

import SeasonFilters from "./Filters/SeasonFilters";
import Filters from "./Filters/TagFilters";
import MobileCard from "./MobileCard";
import { getSeason } from "./HandleDate";

import DropdownArrow from "icons/DropdownArrow";
import Sun from "icons/SunIcon";
import Snowflake from "icons/SnowflakeIcon";
import NorthernLights from "icons/NorthernLightsIcon";

export class Glider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: 0,
      filterOpen: false,
    };
    this.swiperRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.data && this.props.data.length) {
      this.setState({ data: this.props.data }, () => this.initSwiper());
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.data !== prevProps.data) {
      if (this.props.data && this.props.data.length) {
        this.setState({ data: this.props.data }, () => this.initSwiper());
      }
    }
  }

  initSwiper = () => {
    this.swiper = new Swiper(this.swiperRef.current, {
      slidesPerView: "auto",
    });
    this.swiper.on("slideChange", () => {
      this.setState({ active: this.swiper.realIndex });
      this.swiper.allowSlideNext =
        this.swiper.realIndex == this.state.data.length - 1 ? false : true;
    });
  };

  handleFilter(tag) {
    this.swiper.destroy();
    if (tag === "all") {
      this.setState({ data: this.props.data }, () => this.initSwiper());
    } else {
      let filtered = this.props.data.filter((activity) =>
        activity.acf.tags.includes(tag)
      );
      this.setState({ data: filtered }, () => this.initSwiper());
    }
  }

  handleClick() {
    this.setState({ filterOpen: !this.state.filterOpen });
  }

  handleSeasonFilter(season) {
    if (this.swiper) this.swiper.destroy();
    this.props.handleSeasonFilter(season);
  }

  render() {
    const { active, filterOpen, data } = this.state;
    const { title, icon, filter, season, seasons, seasonOverride } = this.props;

    if (data && data.length) {
      return (
        <Wrapper className={this.props.className}>
          <Container grid>
            <TitleGridElement colStart={1} colEnd={8} align={"center"}>
              <div>
                {icon && (
                  <StyledIcon icon={icon}>
                    {icon === "sun" ? (
                      <Sun />
                    ) : icon === "snow" ? (
                      <Snowflake />
                    ) : icon === "northern_lights" ? (
                      <NorthernLights />
                    ) : null}
                  </StyledIcon>
                )}
                <h1>{title}</h1>
              </div>
              {season && (season !== "all" ? <p>{getSeason(season)}</p> : null)}
            </TitleGridElement>
          </Container>

          <Container grid>
            <DropdownGridElement colStart={1} colEnd={5} colSpan>
              {filter && (
                <div>
                  <FilterButton
                    onClick={() => this.handleClick()}
                    open={filterOpen}
                  >
                    <p>{WP.trans.chooseCategory}</p>
                    <DropdownArrow link={!filterOpen} />
                  </FilterButton>
                  {filterOpen && (
                    <Filters
                      data={data}
                      active={active}
                      season={season}
                      handleFilter={(tag) => this.handleFilter(tag)}
                    />
                  )}
                </div>
              )}
            </DropdownGridElement>
            {seasons && (
              <GridElement colStart={1} colEnd={8} colSpan>
                <SeasonFilters
                  data={data}
                  active={active}
                  season={season}
                  handleSeasonFilter={(season) =>
                    this.handleSeasonFilter(season)
                  }
                  seasonOverride={seasonOverride}
                />
              </GridElement>
            )}
          </Container>

          <Container bleedRight>
            <div className='swiper-container' ref={this.swiperRef}>
              <div className='swiper-wrapper'>
                {data.map((item) => (
                  <div className='swiper-slide' key={item.id}>
                    <MobileCard item={item} />
                  </div>
                ))}
                {data.length > 2 ? <div className='swiper-slide'></div> : null}
              </div>
            </div>
          </Container>
        </Wrapper>
      );
    } else return null;
  }
}

export default Glider;

const Wrapper = styled.section`
  user-select: none;
  margin-bottom: ${(props) => props.theme.spacing.elementXL};

  .swiper-container {
    display: flex;
    overflow-x: hidden;
    .swiper-wrapper {
      display: flex;
      align-items: center;
      .swiper-slide {
        display: flex;
        flex-direction: column;
        width: 73.2309231vw;
        color: black;
        z-index: 1000;
        padding-right: 7.077vw;

        a {
          color: ${(props) => props.theme.colors.text};
        }
      }
    }
  }
`;

const TitleGridElement = styled(GridElement)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${(props) => props.theme.spacing.contentXL};

  > div {
    display: flex;
    align-items: center;
  }
`;

const DropdownGridElement = styled(GridElement)`
  margin-bottom: ${(props) => props.theme.spacing.contentXL};
`;

const FilterButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${(props) => props.theme.colors.link};
  text-decoration: underline;
  transition: all 0.2s ease-in;

  p {
    margin-right: ${(props) => props.theme.spacing.contentS};
  }

  svg {
    transform: rotate(180deg);
    transition: all 0.2s ease-in;
  }

  ${(props) =>
    props.open &&
    css`
      text-decoration: none;
      color: ${(props) => props.theme.colors.text};

      svg {
        transform: rotate(360deg);
      }
    `}
`;

const StyledIcon = styled.div`
  margin-right: ${(props) => props.theme.spacing.contentM};

  svg {
    width: ${(props) =>
      props.icon === "sun" ? 36.64 : props.icon === "snow" ? 31.2 : 33.46}px;
    height: ${(props) =>
      props.icon === "sun" ? 36.64 : props.icon === "snow" ? 35.7 : 40.9}px;
  }
`;
